import { Permission } from "domain/entities/permission";
import { Function } from "../../domain/entities/function";
import { MenuItemModel, MenuSectionModel } from "./models/menu-item.model";
import { translateText } from "infra/translation/translate";

export const transformToMenuItem = (
  functions: Function[] | undefined,
  permissions: Permission[] | undefined,
): MenuItemModel[] => {
  if (!functions) return [];

  const hasPermissionAccess = (functionId: string): boolean => {
    const permission = permissions?.find(
      (item) => item.functionId === functionId,
    );
    return permission ? true : false;
  };

  const menuItems: MenuItemModel[] = [];
  functions.forEach((item) => {
    if (item.id && hasPermissionAccess(item.id)) {
      menuItems.push({
        label: translateText(item.label, "pt"),
        icon: `pi ${item.icon}`,
        path: `/${item.name}`,
        category: item.category,
        order: item.order,
      });
    }
  });

  return menuItems;
};

// Nova função para transformar em seções agrupadas por categoria
export const transformToMenuSections = (
  functions: Function[] | undefined,
  permissions: Permission[] | undefined,
): MenuSectionModel[] => {
  if (!functions) return [];

  const hasPermissionAccess = (functionId: string): boolean => {
    const permission = permissions?.find(
      (item) => item.functionId === functionId,
    );
    return permission ? true : false;
  };

  // Filtrar apenas funções com permissão e excluir relatórios duplicados
  // const authorizedFunctions = functions.filter(
  //   (item) => {
  //     // Excluir funções relacionadas a relatórios que já estão sendo adicionadas manualmente
  //     const isReportsFunction = item.name?.toLowerCase().includes('report') ||
  //       item.label?.toLowerCase().includes('relatório') ||
  //       item.category?.toLowerCase() === 'relatórios';

  //     return item.id && hasPermissionAccess(item.id) && !isReportsFunction;
  //   }
  // );

  // Agrupar por categoria
  const groupedByCategory = functions
    .filter((fn) => hasPermissionAccess(fn.id ?? ""))
    .reduce(
      (acc, item) => {
        const category = item.category || "Outros";
        if (!acc[category]) {
          acc[category] = [];
        }
        acc[category].push({
          label: translateText(item.label, "pt"),
          icon: `pi ${item.icon}`,
          path: `/${item.name}`,
          category: item.category,
          order: item.order,
        });
        return acc;
      },
      {} as Record<string, MenuItemModel[]>,
    );
  console.log(groupedByCategory);

  // Definir ícones para cada categoria
  const categoryIcons: Record<string, string> = {
    Início: "pi-home",
    "Recursos Humanos": "pi-users",
    Patrimónios: "pi-building",
    Finanças: "pi-euro",
    Projetos: "pi-address-book",
    Relatórios: "pi-download",
    Geral: "pi-list",
    Comunicação: "pi-globe",
    Administração: "pi-cog",
    Outros: "pi-ellipsis-h",
  };

  // Definir ordem das categorias
  const categoryOrder: Record<string, number> = {
    Início: 1,
    "Recursos Humanos": 2,
    Patrimónios: 3,
    Finanças: 4,
    Projetos: 5,
    Relatórios: 6,
    Geral: 7,
    Comunicação: 8,
    Administração: 9,
    Outros: 99,
  };

  // Converter para array de seções e ordenar
  const sections: MenuSectionModel[] = Object.entries(groupedByCategory)
    .map(([category, items]) => ({
      label: category, // Renomear Relatórios para Exportar ficheiro
      // label: category === 'Relatórios' ? 'Exportar ficheiro' : category, // Renomear Relatórios para Exportar ficheiro
      icon: `pi pi-fw ${categoryIcons[category] || categoryIcons["Outros"]}`,
      items: items.sort((a, b) => (a.order || 0) - (b.order || 0)),
      expanded: category === "Início", // Expandir apenas a seção "Início" por padrão
    }))
    .sort(
      (a, b) => (categoryOrder[a.label] || 99) - (categoryOrder[b.label] || 99),
    );
  // .sort((a, b) => (categoryOrder[a.label === 'Exportar ficheiro' ? 'Relatórios' : a.label] || 99) - (categoryOrder[b.label === 'Exportar ficheiro' ? 'Relatórios' : b.label] || 99));

  return sections;
};
